const main = {
    main: {
        missionSupport1: '위성 미션을 위한 올인원 관리 및 지원 서비스를 제공합니다.',
        missionSupport2: 'IOPS SPACE와 전 세계 어디에서나 연결하여 우주 비즈니스를 확장하세요.',
        getStarted: '시작하기',
        overview: {
            sectionTitle: 'Overview',
            sectionSubtitle: '위성을 위한 올인원 솔루션',
            card1Title: 'Orbital Scheduling',
            card1Desc: '위성 궤도 예측 및 지상국 접속 스케줄링 기능을 제공합니다.',
            card2Title: 'Mission Control',
            card2Desc: '위성의 실시간 궤도 추적과 AI 기반 미션 제어를 지원합니다.',
            card3Title: 'Contribute',
            card3Desc: '요청에 따라 데이터 처리 및 분석 솔루션을 제공합니다.'
        },
        slider: {
            slide1: {
                title: '검증된 기술력을 확인하세요',
                desc: '우리는 사업을 통해 소프트웨어를 지속적으로 개선해왔으며,\n국제 표준 정보보호 및 보안 인증을 취득했습니다.',
                stat1: {
                    line1: '국가 위성 운영 프로젝트',
                    line2: '(4,230억 원 이상)'
                },
                stat2: {
                    line1: '위성 운영 소프트웨어',
                    line2: '개발 실적'
                },
                stat3: {
                    line1: '자체 개발 위성',
                    line2: '운영/제어 소프트웨어'
                }
            },
            slide2: {
                title: '위성 통신 커버리지를 확장하세요',
                desc: '지상국 네트워크, 클라우드 모뎀, 글로벌 파트너 생태계를 제공합니다.'
            },
            slide3: {
                title: 'IOPS의 전문성을 경험해보세요',
                desc: '150명의 전문가들이 AI 개발, 위성 통신 시스템 개발, 분석, 기획, 고객 서비스를 담당하고 있습니다.'
            }
        },
        benefits: {
            sectionTitle: 'Benefits',
            sectionSubtitle: '쉽고 합리적인 위성 운용 솔루션',
            card1: {
                title: '이메일 주소만 있으면 시작 가능',
                desc: '불필요한 정보 수집 없이 위성 데이터를 수집할 수 있습니다.'
            },
            card2: {
                title: '사용한 안테나 시간만큼만 요금 부과',
                desc: '비용과 시간을 절감하며 효율적인 위성 사업을 운영할 수 있습니다.'
            },
            card3: {
                title: '실시간 & 자동 제어 시스템',
                desc: '24시간 위성 모니터링 및 자동 제어 시스템을 운영합니다.'
            }
        },
        features: {
            sectionTitle: 'Features',
            sectionSubtitle: '이용 방법',
            steps: {
                getStarted: {
                    title: '시작하기',
                    desc: 'IOPS SPACE에 지금 바로 접속하세요!'
                },
                manageSpacecraft: {
                    title: '위성 관리',
                    desc: '위성 정보를 등록하고 관리하세요.'
                },
                contactProfile: {
                    title: '교신 프로필',
                    desc: '지상국을 검색하고 연결하세요.'
                },
                scheduleContact: {
                    title: '교신 예약',
                    desc: '한 번의 클릭으로 교신을 예약하세요.'
                }
            }
        },
        contact: {
            sectionTitle: 'Contact',
            sectionSubtitle: '서비스 이용을 원하시나요?',
            form: {
                enquiryType: '문의 유형',
                name: '이름',
                namePlaceholder: '이름을 입력하세요',
                company: '회사 / 부서',
                companyPlaceholder: '소속된 회사 또는 부서를 입력하세요',
                email: '연락처',
                emailPlaceholder: '이메일 주소를 입력하세요',
                country: '국가',
                inquiry: '문의 내용',
                agree:
                    '개인정보 처리방침 및 이용약관을 확인하고 동의합니다.\n하단의 내용을 반드시 확인해주세요.',
                submit: '문의하기',
                enquiryOptions: {
                    use: '지상국 사용 문의',
                    share: '지상국 공유 제안 문의',
                    estimate: '견적 요청',
                    press: '보도/언론 문의',
                    other: '기타(문의)'
                }
            }
        }
    }
}

export default main;